import Box from '@mui/material/Box';
import type { ReactNode } from 'react';
import { percent, type Sentiment, sentimentOf } from './performance/data/format';

interface DeltaChipProps {
  value: number | null;
  /** Force a tone where the sign does not carry meaning, e.g. a spend change. */
  sentiment?: Sentiment;
}

export function DeltaChip({ value, sentiment }: DeltaChipProps): ReactNode {
  const digits = Math.abs(value ?? 0) >= 0.1 ? 0 : 1;
  // Arrow and tone come from the printed number, so a chip that reads 0.0% stays neutral.
  const shown = value === null ? null : Number((value * 100).toFixed(digits));
  const tone = sentiment ?? sentimentOf(shown);
  const arrow = shown === null || shown === 0 ? '' : shown > 0 ? '↑ ' : '↓ ';
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        fontSize: 11,
        fontWeight: 600,
        px: 1,
        py: 0.5,
        borderRadius: 0.5,
        ...(tone === 'good' && { color: 'success.dark', bgcolor: 'success.bg' }),
        ...(tone === 'bad' && { color: 'error.dark', bgcolor: 'error.bg' }),
        ...(tone === 'neutral' && { color: 'text.secondary', bgcolor: 'background.default' }),
      }}
    >
      {arrow}
      {percent(value === null ? null : Math.abs(value), digits)}
    </Box>
  );
}
